{
  "on": "sobre",
  "none": "Ninguno",
  "device": "equipo | equipo | equipos",
  "operation": "operación | operación | operaciones",
  "profile": "perfil | perfil | perfiles",
  "application": "aplicación | aplicación | aplicaciones",
  "campaign": "campaña | campaña | campañas",
  "user": "usuario | usuario | usuarios",
  "group": "grupo | grupo | grupos",
  "userGroup": "grupo de usuarios | grupo de usuarios | grupos de usuarios",
  "firmware": "firmware | firmware | firmwares",
  "applicationMgt": "aplicación | aplicación |aplicaciones",
  "dtwins": "equipo | equipo | equipos"
}
